import { Component, Input } from '@angular/core';
import { Filter } from '../../models/filter-models';
import { EquipmentType } from '../../models/equipment-type.enum';
import { Rarity } from '../../models/enums';
import { FilterService } from '../../services/filter.service';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { FormsModule } from '@angular/forms';
import { ItemDataService } from '../../services/item-data.service';
import { BaseType } from '../../models/item-data-models';
import { JewelleryTierService } from '../../services/tiering/jewellery-tier.service';
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';

@Component({
  selector: 'app-special-equipment-filters-poe2',
  imports: [FilterTitleComponent, EquipmentTierPickerComponent, AutocompleteComponent, FormsModule, FilterCheckboxGroupComponent],
  templateUrl: './special-equipment-filters-poe2.component.html',
})
export class SpecialEquipmentFiltersPoe2Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  specialJewelleryBaseTypes: string[] = [];
  excellentSpecialJewelleryBaseTypes: string[] = [];
  goodSpecialJewelleryBaseTypes: string[] = [];
  otherSpecialJewelleryBaseTypes: string[] = [];
  allOtherSpecialJewelleryBaseTypesTypes: BaseType[] = [];

  EquipmentType = EquipmentType;
  Rarity = Rarity;

  constructor(
    private filterService: FilterService,
    private itemDataService: ItemDataService,
    jewelleryTierService: JewelleryTierService,
  ) {
    super();

    this.specialJewelleryBaseTypes = this.itemDataService.getSpecialJewelleryBaseTypes();
    const specialSet = new Set(this.specialJewelleryBaseTypes);
    const jewelleryTierData = jewelleryTierService.getJewelleryTierData();
    this.excellentSpecialJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Excellent' && specialSet.has(j.name)).map(j => j.name);
    this.goodSpecialJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Good' && specialSet.has(j.name)).map(j => j.name);
    this.otherSpecialJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Other' && specialSet.has(j.name)).map(j => j.name);

    this.allOtherSpecialJewelleryBaseTypesTypes = this.itemDataService.getItemData().find(i => i.itemType === 'Amulets')!.baseTypes
      .concat(this.itemDataService.getItemData().find(i => i.itemType === 'Rings')!.baseTypes)
      .concat(this.itemDataService.getItemData().find(i => i.itemType === 'Belts')!.baseTypes)
      .filter(b => this.specialJewelleryBaseTypes.includes(b.name));
  }

  toggleHighlightAnointedAmulets = () => {
    this.filter.showAnointedAmulets = !this.filter.showAnointedAmulets;
    this.updateFilter();
  }

  toggleHighlightSpecialGear = () => {
    this.filter.showSpecialGear = !this.filter.showSpecialGear;
    this.updateFilter();
  }

  toggleHighlightExcellentSpecialJewelleryBaseTypes = () => {
    this.filter.showExcellentSpecialJewelleryBaseTypes = !this.filter.showExcellentSpecialJewelleryBaseTypes;
    if (!this.filter.showExcellentSpecialJewelleryBaseTypes) {
      this.filter.showGoodSpecialJewelleryBaseTypes = false;
    }
    this.updateFilter();
  }

  toggleHighlightOtherSpecialJewelleryBaseTypes = () => {
    this.filter.showOtherSpecialJewelleryBaseTypes = !this.filter.showOtherSpecialJewelleryBaseTypes;
    this.updateFilter();
  }

  highlightOtherSpecialJewelleryBaseTypesTypesChanged(newValues: string[]) {
    this.filter.showOtherSpecialJewelleryBaseTypesTypes = newValues;
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
